<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">Add Call Costs</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
   </div>
   <form [formGroup]="form" (ngSubmit)="onCreate()">
      <mat-dialog-content>
         <mat-radio-group class="add-provider-radio-group" formControlName="providerId" (change)="onRadioChange($event)"
            ><div class="radio-column"
               ><mat-radio-button color="primary" [value]="'Inteliquent'" checked="false">Inteliquent</mat-radio-button
               ><mat-radio-button color="primary" [value]="'Lumen'" checked="false">Lumen</mat-radio-button>
               @if (isSubmitted && form.get('providerId')?.invalid) {
               <mat-error> Please select a provider. </mat-error>
               }</div
            ></mat-radio-group
         >
         <div class="recording-option-container">
            <ndt-file-upload
               class="prompt-file-upload"
               label="Upload Call Costs"
               acceptedFileTypes=".xls, .xlsx"
               formControlName="File"
               required
            ></ndt-file-upload>
            @if (form.get('File')?.value === null) {
            <mat-error> Please upload a .xls or .xlsx file. </mat-error>
            }
         </div>
      </mat-dialog-content>
      <mat-dialog-actions>
         <button type="submit" title="Create" mat-raised-button>Save</button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
